import { useState } from 'react';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';

import { useSnackbar } from 'web/contexts/SnackbarContext';
import ErrorMessage from 'components/ErrorMessage';
import FormIntroText from 'components/form/FormIntroText';

import { Button } from 'web/form/Form';

import UserProfileForm from 'web/components/user/userProfile/UserProfileForm';
import UserProfileFormFields from 'web/components/user/userProfile/UserProfileFormFields';

export default function UserDetailsVerifyModal({
	user,
	setIsOpen,
	sessionKey,
}) {
	const { notify } = useSnackbar();

	const [errors, setErrors] = useState(null);

	const onSuccess = () => {
		notify('Verifiseringen var vellykket!');
		setIsOpen(false);
	};

	const onError = err => {
		setErrors(err);
	};

	const onCancel = () => {
		notify('Endringer ble ikke lagret.', 'warning');
	};

	const onSkip = () => {
		setIsOpen(false);

		// Save that the user wants to hide the modal for the rest of the session
		sessionStorage.setItem(sessionKey, 'true');
	};

	return (
		<>
			<DialogTitle id="user-verification-dialog-title">
				Bekreft din informasjon
			</DialogTitle>
			<UserProfileForm
				user={user}
				onSuccess={onSuccess}
				onError={onError}
				onCancel={onCancel}
				refetchQueries={['currentUser', 'findOneUser']}
			>
				<DialogContent
					sx={{ paddingTop: 0, maxWidth: '100%', width: '600px' }}
				>
					<FormIntroText>
						Se over og sjekk at informasjonen om deg stemmer.
					</FormIntroText>

					<ErrorMessage errors={[errors]} />

					<Stack spacing={3}>
						<UserProfileFormFields />
					</Stack>
				</DialogContent>

				<DialogActions>
					<Button onClick={onSkip}>Hopp over</Button>

					<Button variant="contained" type="submit">
						Bekreft
					</Button>
				</DialogActions>
			</UserProfileForm>
		</>
	);
}
